import PropTypes from "prop-types"
import { Avatar, ListItemButton, ListItemAvatar, ListItemText } from "@mui/material"

export default function Result({ primary, secondary, icon, type, onClick }) {
  return <ListItemButton dense className="base-search-result" onClick={onClick}>
    <ListItemAvatar>
      <Avatar className={`avatar-${type}`}>
        {icon}
      </Avatar>
    </ListItemAvatar>
    <ListItemText primary={primary} secondary={secondary} />
  </ListItemButton>
}

Result.propTypes = {
  primary: PropTypes.string,
  secondary: PropTypes.string,
  icon: PropTypes.element,
  type: PropTypes.string,
  onClick: PropTypes.func.isRequired,
}
